<section *ngIf="activities">
  <app-attendee-activity-collection
    [activities]="activities"
    [description]="section.section_informations?.description"
    [title]="section.section_informations?.title"
    [seeMore]="section.see_more"
    [moreLink]="link"
  >
  </app-attendee-activity-collection>
</section>
